declare global {
  interface Window {
    dataLayer: unknown[]
    gtag: (
      command: string,
      targetId: string | Date,
      config?: Record<string, unknown>,
    ) => void
  }
}

const GA_ID = window.env?.GA_ID

export function trackPageView(path: string) {
  if (!GA_ID || !window.gtag) return

  window.gtag('config', GA_ID, {
    page_path: path,
    page_title: document.title,
  })
}

export function trackEvent(action: string, params?: Record<string, unknown>) {
  if (!GA_ID || !window.gtag) return

  window.gtag('event', action, params)
}
